document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.dg-pc-configurator').forEach(function (configurator) {
    const baseVariantId = Number(configurator.dataset.baseVariantId);
    const basePrice = Number(configurator.dataset.basePrice || 0);
    const baseComparePrice = Number(configurator.dataset.baseComparePrice || basePrice);
    const baseSku = configurator.dataset.baseSku || '';
    const baseSkuPart = configurator.dataset.baseSkuPart || '';
    const productTitle = configurator.dataset.productTitle || 'PC personalizado';
    const productHandle = (configurator.dataset.productHandle || '').toLowerCase();
    const isNemesisConfigurator = productHandle.includes('nemesis') || productTitle.toLowerCase().includes('nemesis');

    const totalEl = configurator.querySelector('[data-dg-total]');
    const compareTotalEl = configurator.querySelector('[data-dg-compare-total]');
    const savingsEl = configurator.querySelector('[data-dg-savings]');
    const priceStatusEl = configurator.querySelector('[data-dg-price-status]');
    const compatibilityStatusEl = configurator.querySelector('[data-dg-compatibility-status]');
    const cartStatusEl = configurator.querySelector('[data-dg-cart-status]');
    const addButton = configurator.querySelector('.dg-config-add');
    const qtyInput = configurator.querySelector('[data-dg-quantity]');
    const qtyMinus = configurator.querySelector('[data-dg-qty-minus]');
    const qtyPlus = configurator.querySelector('[data-dg-qty-plus]');
    const configGroups = Array.from(
      configurator.querySelectorAll('.dg-config-group')
    );
    const moneyFormatter = new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR'
    });
    const accessibleIntegerMoneyFormatter = new Intl.NumberFormat('es-ES', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0
    });
    const accessibleDecimalMoneyFormatter = new Intl.NumberFormat('es-ES', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    });
    let lastPriceStatusKey = null;
    let previousIntegratedGpuAvailability = null;

    const urlParamByGroup = {
      'Procesador': 'cpu',
      'Tarjeta Gráfica': 'gpu',
      'Memoria RAM': 'ram',
      'Almacenamiento Principal': 'ssd',
      'Almacenamiento Secundario': 'ssd2',
        };
    const configUrlParams = Object.values(urlParamByGroup);
    const defaultUrlValues = new Map();
    let isApplyingUrlState = false;

    function getGroupUrlParam(group) {
      return urlParamByGroup[group.dataset.group] || '';
    }

    function getOptionUrlValue(button) {
      return button && button.dataset ? (button.dataset.urlValue || '') : '';
    }

    function captureDefaultUrlState() {
      configGroups.forEach(function (group) {
        const param = getGroupUrlParam(group);
        const active = group.querySelector('.dg-config-option.is-active');
        const value = getOptionUrlValue(active);

        if (param && value) {
          defaultUrlValues.set(param, value);
        }
      });
    }

    function applyConfigurationFromUrl() {
      const params = new URLSearchParams(window.location.search);
      isApplyingUrlState = true;

      configGroups.forEach(function (group) {
        const param = getGroupUrlParam(group);
        const requestedValue = param ? params.get(param) : null;
        if (!requestedValue) return;

        const matchingOption = Array.from(group.querySelectorAll('.dg-config-option')).find(function (button) {
          return getOptionUrlValue(button) === requestedValue;
        });

        if (matchingOption && isSelectableOption(matchingOption)) {
          setSelectedOption(group, matchingOption);
        }
      });

      applyNemesisGpuRules();
      isApplyingUrlState = false;
    }

    function syncConfigurationToUrl() {
      if (isApplyingUrlState) return;

      const url = new URL(window.location.href);
      const currentValues = new Map();
      let hasCustomConfiguration = false;

      // Nuestro configurador no usa la variante nativa de Shopify.
      url.searchParams.delete('variant');
      configUrlParams.forEach(function (param) {
        url.searchParams.delete(param);
      });

      configGroups.forEach(function (group) {
        const param = getGroupUrlParam(group);
        const active = group.querySelector('.dg-config-option.is-active');
        const value = getOptionUrlValue(active);

        if (!param || !value) return;

        currentValues.set(param, value);

        if (defaultUrlValues.get(param) !== value) {
          hasCustomConfiguration = true;
        }
      });

      // Si todo sigue en la configuracion base, mantenemos la PDP limpia.
      // En cuanto cambia un componente, escribimos la configuracion completa
      // para que la URL compartida sea autosuficiente aunque cambien los defaults.
      if (hasCustomConfiguration) {
        configUrlParams.forEach(function (param) {
          const value = currentValues.get(param);
          if (value) {
            url.searchParams.set(param, value);
          }
        });
      }

      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }

    function formatMoney(cents) {
      return moneyFormatter.format(cents / 100);
    }

    function getQuantity() {
      const value = parseInt(qtyInput.value, 10);
      return Number.isFinite(value) && value > 0 ? value : 1;
    }

    function setQuantity(value) {
      const cleanValue = Number.isFinite(value) && value > 0 ? value : 1;
      qtyInput.value = cleanValue;
      updateTotal();
    }

    function getSelectedOptions() {
      const selected = [];

      configGroups.forEach(function (group) {
        const active = group.querySelector('.dg-config-option.is-active');
        if (!active) return;

        selected.push({
          group: group.dataset.group,
          title: active.dataset.title,
          variantId: Number(active.dataset.variantId),
          price: Number(active.dataset.price || 0),
          comparePrice: Number(active.dataset.comparePrice || active.dataset.price || 0),
          sku: active.dataset.sku || '',
          skuPart: active.dataset.skuPart || ''
        });
      });

      return selected;
    }

    function calculateTotals(selected, quantity) {
      const unitPrice = selected.reduce(function (sum, option) {
        return sum + option.price;
      }, basePrice);

      const unitComparePrice = selected.reduce(function (sum, option) {
        return sum + Math.max(option.comparePrice, option.price);
      }, Math.max(baseComparePrice, basePrice));

      const totalPrice = unitPrice * quantity;
      const totalComparePrice = unitComparePrice * quantity;
      const savings = Math.max(totalComparePrice - totalPrice, 0);
      const savingsPercentage = totalComparePrice > 0
        ? Math.round((savings / totalComparePrice) * 100)
        : 0;

      return {
        unitPrice: unitPrice,
        unitComparePrice: unitComparePrice,
        price: totalPrice,
        comparePrice: totalComparePrice,
        savings: savings,
        savingsPercentage: savingsPercentage
      };
    }

    function getUnitTotal() {
      return calculateTotals(getSelectedOptions(), 1).unitPrice;
    }

    function getCompactSummary(selected) {
      const cpu = selected.find(function (item) { return item.group === 'Procesador'; });
      const gpu = selected.find(function (item) { return item.group === 'Tarjeta Gráfica'; });
      const ram = selected.find(function (item) { return item.group === 'Memoria RAM'; });

      return [cpu, gpu, ram]
        .filter(Boolean)
        .map(function (item) {
          return item.title
            .replace('Intel Core ', '')
            .replace('Intel® Core™ ', '')
            .replace('NVIDIA GeForce RTX ', 'RTX ')
            .replace('GeForce RTX ', 'RTX ');
        })
        .join(' · ');
    }

    function dispatchConfigurationChange(totals, selected) {
      document.dispatchEvent(
        new CustomEvent('dg:configuration-change', {
          bubbles: true,
          detail: {
            productId: configurator.dataset.productId || null,
            productTitle: productTitle,
            priceCents: totals.price,
            priceFormatted: formatMoney(totals.price),
            comparePriceCents: totals.comparePrice,
            comparePriceFormatted: formatMoney(totals.comparePrice),
            savingsCents: totals.savings,
            savingsFormatted: formatMoney(totals.savings),
            savingsPercentage: totals.savingsPercentage,
            summary: getCompactSummary(selected),
            selected: selected
          }
        })
      );
    }

    function formatAccessibleMoney(cents) {
      const euros = cents / 100;
      const formatter = Number.isInteger(euros)
        ? accessibleIntegerMoneyFormatter
        : accessibleDecimalMoneyFormatter;
      const formatted = formatter.format(euros);

      return formatted + ' euros';
    }

    function updatePriceStatus(totals) {
      if (!priceStatusEl) return;

      const priceStatusKey = [totals.price, totals.comparePrice, totals.savings].join('|');

      if (lastPriceStatusKey === null) {
        lastPriceStatusKey = priceStatusKey;
        return;
      }

      if (priceStatusKey === lastPriceStatusKey) return;

      lastPriceStatusKey = priceStatusKey;

      const messageParts = ['Precio actualizado: ' + formatAccessibleMoney(totals.price) + '.'];

      if (totals.savings > 0) {
        messageParts.push('Ahorro: ' + formatAccessibleMoney(totals.savings) + '.');
      }

      const message = messageParts.join(' ');

      if (priceStatusEl.textContent !== message) {
        priceStatusEl.textContent = message;
      }
    }

    function updateCompatibilityStatus(message) {
      if (!compatibilityStatusEl || !message) return;

      if (compatibilityStatusEl.textContent !== message) {
        compatibilityStatusEl.textContent = message;
      }
    }

    function updateCartStatus(message) {
      if (!cartStatusEl || !message) return;

      if (cartStatusEl.textContent !== message) {
        cartStatusEl.textContent = message;
        return;
      }

      cartStatusEl.textContent = '';

      requestAnimationFrame(() => {
        if (cartStatusEl.isConnected) {
          cartStatusEl.textContent = message;
        }
      });
    }

    function updateTotal() {
      const selected = getSelectedOptions();
      const totals = calculateTotals(selected, getQuantity());

      if (totalEl) {
        totalEl.textContent = formatMoney(totals.price);
      }

      if (compareTotalEl) {
        compareTotalEl.textContent = formatMoney(totals.comparePrice);
        compareTotalEl.classList.toggle('is-hidden', totals.savings <= 0);
      }

      if (savingsEl) {
        savingsEl.textContent = 'Ahorras ' + formatMoney(totals.savings);
        savingsEl.classList.toggle('is-hidden', totals.savings <= 0);
      }

      updatePriceStatus(totals);
      dispatchConfigurationChange(totals, selected);
    }

    function getCartSectionIds() {
      return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
        .map(function (component) {
          return component.dataset.sectionId;
        })
        .filter(Boolean)
        .filter(function (value, index, self) {
          return self.indexOf(value) === index;
        });
    }

    function openCartDrawer() {
      const drawer = document.querySelector('cart-drawer-component');

      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }

      const trigger = document.querySelector('[aria-controls="cart-drawer"], a[href="/cart"]');

      if (trigger) {
        trigger.dispatchEvent(new Event('click', { bubbles: true }));
      }
    }

    function getVisibleItemCount(cartItems) {
      return (cartItems || []).reduce(function (total, item) {
        const properties = item.properties || {};

        if (properties._dg_component === 'true') {
          return total;
        }

        return total + item.quantity;
      }, 0);
    }

    function isNemesisIntegratedAllowedForCpu(cpuTitle) {
      const normalizedCpuTitle = (cpuTitle || '').toLowerCase();
      return normalizedCpuTitle.includes('8500g') || normalizedCpuTitle.includes('8700g');
    }

    function isIntegratedGpuButton(button) {
      return ((button && button.dataset.title) || '').toLowerCase().includes('integrada');
    }

    function isSelectableOption(button) {
      return button
        && !button.disabled
        && !button.classList.contains('is-hidden')
        && button.getAttribute('aria-hidden') !== 'true';
    }

    function getSelectableOptions(group) {
      return Array.from(group.querySelectorAll('.dg-config-option')).filter(isSelectableOption);
    }

    function setSelectedOption(group, selectedButton) {
      group.querySelectorAll('.dg-config-option').forEach(function (button) {
        const isSelected = button === selectedButton;

        button.classList.toggle('is-active', isSelected);
        button.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        button.setAttribute('tabindex', isSelected ? '0' : '-1');
      });
    }

    function selectOption(button) {
      if (!isSelectableOption(button)) return;

      const group = button.closest('.dg-config-group');
      if (!group) return;

      setSelectedOption(group, button);
      applyNemesisGpuRules();
      updateTotal();
      syncConfigurationToUrl();
    }

    function moveSelectionByKey(group, currentButton, key) {
      const options = getSelectableOptions(group);
      if (!options.length) return;

      const currentIndex = options.indexOf(currentButton);
      const safeIndex = currentIndex >= 0 ? currentIndex : 0;
      let nextIndex = safeIndex;

      if (key === 'ArrowRight' || key === 'ArrowDown') {
        nextIndex = (safeIndex + 1) % options.length;
      } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
        nextIndex = (safeIndex - 1 + options.length) % options.length;
      } else if (key === 'Home') {
        nextIndex = 0;
      } else if (key === 'End') {
        nextIndex = options.length - 1;
      }

      const nextButton = options[nextIndex];
      selectOption(nextButton);
      nextButton.focus();
    }

    function applyNemesisGpuRules() {
      if (!isNemesisConfigurator) return;

      const cpuGroup = configurator.querySelector('.dg-config-group--cpu');
      const gpuGroup = configurator.querySelector('.dg-config-group--gpu');

      if (!cpuGroup || !gpuGroup) return;

      const activeCpu = cpuGroup.querySelector('.dg-config-option.is-active');
      const activeCpuTitle = activeCpu ? activeCpu.dataset.title : '';
      const allowIntegrated = isNemesisIntegratedAllowedForCpu(activeCpuTitle);
      const integratedGpu = Array.from(gpuGroup.querySelectorAll('.dg-config-option')).find(isIntegratedGpuButton);

      if (!integratedGpu) return;

      const wasIntegratedSelected = integratedGpu.classList.contains('is-active');

      integratedGpu.classList.toggle('is-hidden', !allowIntegrated);
      integratedGpu.disabled = !allowIntegrated;
      integratedGpu.setAttribute('aria-hidden', allowIntegrated ? 'false' : 'true');

      if (!allowIntegrated && integratedGpu.classList.contains('is-active')) {
        const fallbackGpu = Array.from(gpuGroup.querySelectorAll('.dg-config-option')).find(function (button) {
          return !isIntegratedGpuButton(button);
        });

        if (fallbackGpu) {
          setSelectedOption(gpuGroup, fallbackGpu);
        }
      }

      if (previousIntegratedGpuAvailability === null) {
        previousIntegratedGpuAvailability = allowIntegrated;
        return;
      }

      if (previousIntegratedGpuAvailability === allowIntegrated) return;

      previousIntegratedGpuAvailability = allowIntegrated;

      if (allowIntegrated) {
        updateCompatibilityStatus('La gráfica integrada vuelve a estar disponible con el procesador seleccionado.');
        return;
      }

      if (wasIntegratedSelected) {
        updateCompatibilityStatus('La gráfica integrada ya no está disponible porque el procesador seleccionado no incorpora una gráfica integrada compatible. Se ha seleccionado otra tarjeta gráfica.');
        return;
      }

      updateCompatibilityStatus('La gráfica integrada ya no está disponible porque el procesador seleccionado no incorpora una gráfica integrada compatible.');
    }

    function createBundleId(index) {
      return 'DG-' + Date.now() + '-' + index + '-' + Math.random().toString(36).slice(2, 8);
    }

   function buildBundleItems(bundleId, selected, configSku, erpConfigSku, pricing) {
  const bundleSnapshot = {
    version: 1,
    productTitle: productTitle,
    baseVariantId: baseVariantId,
    configSku: configSku,
    erpSku: erpConfigSku,
    pricing: {
      price: pricing.price,
      comparePrice: pricing.comparePrice,
      savings: pricing.savings
    },
    components: selected.map(function (item) {
      return {
        group: item.group,
        title: item.title,
        variantId: item.variantId
      };
    })
  };

  const baseProperties = {
    '_dg_bundle_id': bundleId,
    '_dg_config_sku': configSku,
    '_dg_erp_sku': erpConfigSku,
    '_dg_bundle_signature': erpConfigSku || configSku,
    '_dg_price_total': String(pricing.price),
    '_dg_compare_total': String(pricing.comparePrice),
    '_dg_savings_total': String(pricing.savings),
    '_dg_bundle_snapshot': JSON.stringify(bundleSnapshot)
  };

  const bundleItems = [
    {
      id: baseVariantId,
      quantity: 1,
      properties: baseProperties
    }
  ];

  selected.forEach(function (item) {
    bundleItems.push({
      id: item.variantId,
      quantity: 1,
      properties: {
        '_dg_bundle_id': bundleId,
        '_dg_component': 'true',
        '_dg_parent': productTitle,
        '_dg_group': item.group
      }
    });
  });

  return bundleItems;
}

    configGroups.forEach(function (group) {
      group.querySelectorAll('.dg-config-option').forEach(function (button) {
        button.addEventListener('click', function () {
          selectOption(button);
        });

        button.addEventListener('keydown', function (event) {
          const navigationKeys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];

          if (!navigationKeys.includes(event.key)) return;

          event.preventDefault();
          moveSelectionByKey(group, button, event.key);
        });
      });
    });

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        setQuantity(getQuantity() - 1);
      });
    }

    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        setQuantity(getQuantity() + 1);
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        setQuantity(getQuantity());
      });

      qtyInput.addEventListener('input', function () {
        updateTotal();
      });
    }

    captureDefaultUrlState();
    applyConfigurationFromUrl();
    updateTotal();
    syncConfigurationToUrl();

    addButton.addEventListener('click', async function () {
      const selected = getSelectedOptions();
      const quantity = getQuantity();
      const unitPricing = calculateTotals(selected, 1);

      const configSku = [baseSku].concat(selected.map(function (item) {
        return item.sku;
      })).filter(Boolean).join('-');

      const erpConfigSku = [baseSkuPart].concat(selected.map(function (item) {
        return item.skuPart;
      })).filter(Boolean).join('');

      const items = [];

      for (let i = 0; i < quantity; i += 1) {
        const bundleId = createBundleId(i);
        items.push.apply(items, buildBundleItems(bundleId, selected, configSku, erpConfigSku, unitPricing));
      }

      try {
        addButton.classList.add('is-loading');
        addButton.textContent = 'Añadiendo...';
        updateCartStatus('Añadiendo la configuración al carrito.');

        const sectionIds = getCartSectionIds();

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: items,
            sections: sectionIds.join(','),
            sections_url: window.location.pathname
          })
        });

        if (!response.ok) throw new Error('No se pudo añadir al carrito');

        const responseData = await response.json();
        const visibleItemCount = getVisibleItemCount(responseData.items);

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: responseData,
              sourceId: 'dg-pc-configurator',
              data: {
                itemCount: visibleItemCount,
                source: 'dg-pc-configurator',
                sections: responseData.sections
              }
            }
          })
        );

        addButton.classList.remove('is-loading');
        addButton.textContent = 'Agregado';
        updateCartStatus('La configuración se ha añadido correctamente al carrito.');

        window.requestAnimationFrame(function () {
          openCartDrawer();
        });

        setTimeout(function () {
          addButton.textContent = 'Agregar al carrito';
        }, 1400);
      } catch (error) {
        console.error(error);
        addButton.classList.remove('is-loading');
        addButton.textContent = 'Agregar al carrito';
        updateCartStatus('No se ha podido añadir la configuración al carrito.');
      }
    });
  });
});
